import React from "react";
import { Input } from "antd";
import classNames from "classnames";

// interfaces
import { TextAreaProps } from "./IInput";

//components
import LabelErrorProvider from "../../components/LabelErrorProvider";

// assets
import styles from "../../assets/styles/shared/input.module.scss";

const { TextArea: AntTextArea } = Input;

const Textarea = (props: TextAreaProps) => {
  const {
    wrapperClassName,
    className,
    type = "primary",
    size = "large",
    label,
    error,
    tooltipInfo,
    value,
    maxWords,
    showCount,
    ...rest
  } = props;

  const onKeyPress = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (!maxWords) {
      return null;
    }

    return (e.target as HTMLTextAreaElement).value.split(" ").length > maxWords + 1 ? e.preventDefault() : true;
  };

  const onPaste = (e: React.ClipboardEvent) => {
    if (!maxWords) {
      return null;
    }

    const text = e.clipboardData.getData("text/plain");

    return text.split(" ").length > maxWords + 1 ? e.preventDefault() : true;
  };

  const wordsCount = value ? value.split(" ").length : 0;
  const maxWordsCount = maxWords ? { formatter: () => `${wordsCount}/${maxWords}` } : null;

  return (
    <LabelErrorProvider
      label={label}
      error={error}
      className={wrapperClassName}
      tooltipInfo={tooltipInfo}
    >
      <AntTextArea
        {...rest}
        value={value || ""}
        className={classNames(
          styles["locl-text-input"],
          className,
          styles[`locl-text-input_${type}`]
        )}
        size={size}
        status={error ? "error" : ""}
        onKeyPress={onKeyPress}
        onPaste={onPaste}
        showCount={(showCount && (maxWordsCount || showCount)) as unknown as boolean}
      />
    </LabelErrorProvider>
  );
};

export default Textarea;
